import axios from "@/plugins/axios";

export default {
    getAll(filters) {
        return axios.get('api/panel/tratamientos/colores', { params: filters });
    },
    paginate(filters) {
        return axios.get('api/panel/tratamientos/colores/paginate', { params: filters });
    },
    create() {
        return axios.get('api/panel/tratamientos/colores/create');
    },
    store(data) {
        return axios.post('api/panel/tratamientos/colores', data);
    },
    update(id, data) {
        return axios.post(`api/panel/tratamientos/colores/${id}`, data);
    },
    destroy(id, data) {
        return axios.delete(`api/panel/tratamientos/colores/${id}`, data);
    },
    reorder(data) {
        return axios.post('api/panel/tratamientos/colores/reorder', data);
    }

}